import React__default from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { useConfiguratorContext } from '../../../../Context/ConfiguratorContext.js';
import { usePrivateSteppingContext } from '../../../../Context/PrivateSteppingContext.js';
import { getStepsList, getCurrentStepIndex } from '../../../../state/selectors.internal.js';
import { SecondaryAction } from './SecondaryAction.js';
import { pushDataLayerEvent } from '../../../../utils/data-layer.js';

function SecondaryActionContainer() {
    const { getLabel  } = useIntl();
    const { goToPreviousStep , onModalClose  } = useConfiguratorContext();
    const { configuratorId , selectorProps  } = usePrivateSteppingContext();
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const steps = useSelector((s)=>getStepsList(s, selectorProps)
    );
    const currentStepIndex = useSelector((s)=>getCurrentStepIndex(s, selectorProps)
    );
    const isFirstStep = currentStepIndex === 0;
    const previousSteps = steps.slice(0, currentStepIndex);
    const allPreviousStepsSkipped = previousSteps.every((s)=>s.skip
    );
    const shouldBeClosed = isFirstStep || allPreviousStepsSkipped;
    const handleSecondaryAction = React__default.useCallback(()=>{
        pushDataLayerEvent({
            steps,
            currentStepIndex,
            eventType: shouldBeClosed ? 'rx_close_click' : 'rx_previous_step_click',
            eventCategory: configuratorId === 'rxSun' ? 'rx_sunglasses' : 'rx_glasses'
        });
        if (shouldBeClosed) {
            if (onModalClose) {
                onModalClose();
            }
        } else {
            goToPreviousStep();
        }
    }, [
        configuratorId,
        currentStepIndex,
        goToPreviousStep,
        onModalClose,
        shouldBeClosed,
        steps
    ]);
    return isSmallScreen ? null : /*#__PURE__*/ React__default.createElement(SecondaryAction, {
        onClick: handleSecondaryAction,
        label: getLabel(shouldBeClosed ? 'common.actions.close' : 'common.actions.previous')
    });
}

export { SecondaryActionContainer };
//# sourceMappingURL=SecondaryActionContainer.js.map
